<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ products: ProductDocument[] }>();
</script>

<template>
  <UiEmptyResult v-if="!products.length" title="Aucun produit à afficher" />
  <div v-else class="divide-y-2 border-y-2 [&>*]:py-4">
    <ProductListItem v-for="product in products" :key="product.product_id" :product="product">
      <div class="ml-auto flex items-center gap-2">
        <slot name="actions" :product="product" />
      </div>
    </ProductListItem>
  </div>
</template>
